import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useCart } from '../../context/CartContext';
import './Navbar.css';

export default function Navbar() {
  const { user, logout, isAdmin } = useAuth();
  const { itemCount } = useCart();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/shop?keyword=${encodeURIComponent(searchQuery.trim())}`);
      setSearchQuery('');
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-inner container">
        {/* Logo */}
        <Link to="/" className="navbar-logo">
          <span className="logo-icon">🌿</span>
          <span className="logo-text">PlantShop</span>
        </Link>

        {/* Search */}
        <form className="navbar-search" onSubmit={handleSearch}>
          <input
            type="text"
            placeholder="Search plants & tools..."
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
            className="search-input"
          />
          <button type="submit" className="search-btn" aria-label="Search">🔍</button>
        </form>

        {/* Nav links */}
        <div className="navbar-links">
          <Link to="/shop" className="nav-link">Shop</Link>
          <Link to="/shop?category=indoor-plants" className="nav-link">Plants</Link>
          <Link to="/shop?category=tools" className="nav-link">Tools</Link>
        </div>

        {/* Actions */}
        <div className="navbar-actions">
          {user ? (
            <div className="user-menu">
              <button className="user-trigger" onClick={() => setMenuOpen(!menuOpen)}>
                <span className="user-avatar">{user.name[0].toUpperCase()}</span>
                <span className="user-name">{user.name.split(' ')[0]}</span>
                <span>▾</span>
              </button>
              {menuOpen && (
                <div className="dropdown" onClick={() => setMenuOpen(false)}>
                  <Link to="/profile" className="dropdown-item">👤 My Profile</Link>
                  <Link to="/orders" className="dropdown-item">📦 My Orders</Link>
                  <Link to="/wishlist" className="dropdown-item">❤️ Wishlist</Link>
                  {isAdmin && <Link to="/admin" className="dropdown-item">⚙️ Admin Panel</Link>}
                  <hr className="dropdown-divider" />
                  <button className="dropdown-item dropdown-logout" onClick={logout}>🚪 Logout</button>
                </div>
              )}
            </div>
          ) : (
            <div className="auth-links">
              <Link to="/login" className="nav-link">Login</Link>
              <Link to="/register" className="btn btn-primary btn-sm">Join Us</Link>
            </div>
          )}

          <Link to="/cart" className="cart-btn">
            🛒
            {itemCount > 0 && <span className="cart-badge">{itemCount}</span>}
          </Link>
        </div>
      </div>
    </nav>
  );
}
